/* eslint-disable */
import React from 'react'
import {accounting} from 'accounting'
import HeaderTablePrint from './HeaderTablePrint'
import jMoment from 'moment-jalali'
import cookie from 'react-cookies'

class ProductReportPrint extends React.Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {}

  render() {
    let {printInfo, aggregation} = this.props
    let reporterName = cookie.load('name')
    let columns = [
      'ردیف',
      'نام تامین کننده',
      'کد محصول',
      'نام محصول',
      'تعداد',
      'مقدار',
      'واحد شمارش',
      'پارت تحویل',
      'قیمت کل',
      'تخفیف',
      'قابل پرداخت'
    ]

    return (
      <div className="printSection">
        <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
          <HeaderTablePrint
            header={this.props.centerTitle}
            reporter={reporterName}
            timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
            headerColSpan={11}
            rightColSpan={4}
            centerColSpan={3}
            leftColSpan={4}
            centerSection={this.props.centerSectionPrint}
            rightSection={this.props.rightSectionPrint}
            columns={columns}
          />
          <tbody>
            {printInfo.map((product, index) => (
              <tr key={'i' + index}>
                <td>{index + 1}</td>
                <td>{product.providerName}</td>
                <td>{product.productCode}</td>
                <td>{product.productName}</td>
                <td>{product.productQuantityCount == '0' ? '-' : product.productQuantityCount}</td>
                <td>{product.productQuantityValue}</td>
                <td>{product.productUnitTitle}</td>
                <td>{product.deliveryCount}</td>
                <td className="priceCell">{accounting.formatMoney(product.totalAmount, '', ',')}</td>
                <td className="priceCell">
                  {accounting.formatMoney(
                    Number(product.discountAmount) + Number(product.extraDiscountAmount),
                    '',
                    ','
                  )}
                </td>
                <td className="priceCell">{accounting.formatMoney(product.payableAmount, '', ',')}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={4}>مجموع</td>
              <td colSpan={1}>{aggregation.productQuantityCount}</td>

              <td colSpan={1}>{aggregation.productQuantityValue}</td>
              <td />
              <td colSpan={1}>{aggregation.deliveryCount}</td>
              <td className="priceCell" colSpan={1}>
                {accounting.formatMoney(aggregation.totalAmount, '', ',')}
              </td>
              <td className="priceCell" colSpan={1}>
                {accounting.formatMoney(aggregation.discountAmount + aggregation.extraDiscountAmount, '', '')}
              </td>
              <td className="priceCell" colSpan={1}>
                {accounting.formatMoney(aggregation.payableAmount, '', ',')}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}
export default ProductReportPrint
